import axios from "axios";

export function shopEdit(businessData) {
  let id = businessData.businessId;
  var config = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${id}`,
    data: {
        businessData
    }
  };
  return axios(config);
}

export function updateRichmenu(accountId) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/line-accounts/${accountId}/richmenu`,
    data: data
  };
  return axios(configBusiness);
}

export function assignToSpecificSiAccount(data) {
  let configBusiness = {
    method: "put",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${data.shopId}/si-account`,
    data: data
  };
  return axios(configBusiness);
}